import { useTheme } from '@mui/material';

export const BenefitTimeIcon = () => {
    const theme = useTheme();
    const {
        stroke: { primary: primaryStroke },
        background: { primary: primaryBackground },
    } = theme.colors.other.icon;

    return (
        <svg
            width="56"
            height="56"
            viewBox="0 0 56 56"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <circle cx="28" cy="28" r="15.75" fill={primaryBackground} />
            <path
                d="M28 49C23.8466 49 19.7865 47.7684 16.333 45.4609C12.8796 43.1534 10.188 39.8736 8.59854 36.0364C7.0091 32.1991 6.59323 27.9767 7.40352 23.9031C8.21381 19.8295 10.2139 16.0877 13.1508 13.1508C16.0877 10.2139 19.8295 8.2138 23.9031 7.40351C27.9767 6.59322 32.1991 7.00909 36.0364 8.59853C39.8736 10.188 43.1534 12.8796 45.4609 16.333C47.7684 19.7865 49 23.8466 49 28"
                stroke={primaryStroke}
                strokeWidth="2.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M23.3334 32.6667L28 28V16.3333"
                stroke={primaryStroke}
                strokeWidth="2.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M39.6666 30.3333V37.3333"
                stroke={primaryStroke}
                strokeWidth="2.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M39.55 47.8333H39.7834"
                stroke={primaryStroke}
                strokeWidth="2.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
};
